import { CurrencyCode, Money } from '@lsq-frontend/remote-services/all-java/common-mk0';

export class InvoiceTotals {
    public approvedInvoiceAmount: Money;
    public count: number;
    public paidAmount: Money;
    public feeAmount: Money;
    public eligibleFeeAmount: Money;

    constructor(obj?: Partial<InvoiceTotals>) {
        this.count = obj?.count || 0;
        this.approvedInvoiceAmount = new Money(
            obj?.approvedInvoiceAmount || {
                cents: 0,
                currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE
            }
        );
        this.paidAmount = new Money(
            obj?.paidAmount || {
                cents: 0,
                currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE
            }
        );
        this.feeAmount = new Money(
            obj?.feeAmount || { cents: 0, currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE }
        );
        this.eligibleFeeAmount = new Money(
            obj?.eligibleFeeAmount || { cents: 0, currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE }
        );
    }
}
